import axios from 'axios';

// Token de sesión de mesa: lo recibe el celular al abrir la mesa y se manda en cada llamada pública de esa sesión
const SESSION_URL = /\/api\/public\/(?:sessions|bill)\/(sess_[A-Za-z0-9]+)/;
const key = (sid) => `stoken_${sid}`;

axios.interceptors.request.use((config) => {
  const m = SESSION_URL.exec(config.url || '');
  if (m) {
    const tok = localStorage.getItem(key(m[1]));
    if (tok) config.headers['X-Session-Token'] = tok;
  }
  return config;
});

axios.interceptors.response.use((res) => {
  const d = res.data;
  if (d && d.session_token && d.session_id) localStorage.setItem(key(d.session_id), d.session_token);
  return res;
}, (error) => {
  const m = SESSION_URL.exec(error.config?.url || '');
  if (m && error.response?.status === 401) localStorage.removeItem(key(m[1]));
  return Promise.reject(error);
});
